import template from './sale-type-commercial.jade';
import saleType from '../../../enums/sale-type-commercial';
import validation from './../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular
  .module('cian.addForm.saleTypeCommercial', [])
  .directive('cianAfPriceAndDealTermsSaleTypeCommercial', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService, store) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      this.saleTypes = saleType;

      this.validation = validation(this.form, 'bargainTerms.saleType', {
        required: 'Укажите тип договора',
      });

      this.handleChange = () => {
        const state = store.getState();
        const category = selectAnalyticsOfferStatus(state);

        trackRequiredFieldFill(category, 'sales_type');
      };
    },
    controllerAs: 'saleTypeCommercial',
    template,
  })).name;
